import {
  StyleParamType,
  wixColorParam,
  wixFontParam,
  createStylesParams,
  IStyleParam,
} from '@wix/tpa-settings';
import {
  StyleType,
  wixColor,
  wixFont,
} from '@wix/editor-platform-ooi-metadata-resolver';

export type IStylesParams = {
  backgroundColor: StyleParamType.Color;
  borderColor: StyleParamType.Color;
  titleFont: StyleParamType.Font;
  newTitleFont: StyleParamType.Font;
  primaryFont: StyleParamType.Font;
  textColor: StyleParamType.Color;
  indicatorColor: StyleParamType.Color;
  borderWith: StyleParamType.Number; // the typo is intended :(
};

const titleFontParam: IStyleParam<StyleParamType.Font> = {
  key: 'titleFont',
  type: StyleParamType.Font,
  getDefaultValue: wixFontParam('Heading-M', {
    size: 26,
  }),
  metadata: {
    type: StyleType.font,
    defaultValue: wixFont('wst-heading-5-font'),
  },
};

const stylesParams = createStylesParams<IStylesParams>({
  backgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
    metadata: {
      type: StyleType.backgroundColor,
      defaultValue: wixColor('wst-primary-background-color'),
    },
  },
  borderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-2', 0.75),
    metadata: {
      type: StyleType.borderColor,
      defaultValue: wixColor('wst-button-secondary-color', 0.75),
    },
  },
  titleFont: titleFontParam,
  newTitleFont: {
    type: StyleParamType.Font,
    getDefaultValue: (params) => {
      const previousTitleFont = params.getStyleParamValue(titleFontParam);
      return previousTitleFont
        ? { ...previousTitleFont, size: 26 }
        : wixFontParam('Heading-M', { size: 26 })(params);
    },
    metadata: {
      type: StyleType.font,
      defaultValue: wixFont('wst-heading-5-font'),
    },
  },
  primaryFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {
      size: 14,
    }),
    metadata: {
      type: StyleType.font,
      defaultValue: wixFont('wst-paragraph-2-font'),
    },
  },
  textColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor('wst-paragraph-2-color'),
    },
  },
  indicatorColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8'),
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor('wst-links-and-actions-color'),
    },
  },
  borderWith: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderWidth,
      defaultValue: { type: 'static', value: 0 },
    },
  },
});

export default stylesParams;
